import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/app/(pages)/projects/Projects.jsx");
